import { createMuiTheme } from '@material-ui/core/styles';

export const theme = createMuiTheme({
  shadows: [
    "none","none","none","none","none","none","none","none","none","none",
    "none","none","none","none","none","none","none","none","none","none",
    "none","none","none","none","none"
  ],
  palette: {
    primary: {
      light: '#ff7e73',
      main: '#ed4a47',
      dark: '#b4001f',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ffffff',
      main: '#e0e0e0',
      dark: '#aeaeae',
      contrastText: '#000000',
    },
    indigo: {
      light: '#7a7cff',
      main: '#304ffe',
      dark: '#0026ca',
      contrastText: '#fff',
    },
    text: {
      primary: 'rgba(23, 31, 36, 1)',
      secondary: "rgba(0, 0, 0, 0.54)",
      disabled: "rgba(0, 0, 0, 0.38)",
      hint: "rgba(0, 0, 0, 0.38)",
    }
  },
  typography: {
    fontSize: 13,
  },
  '@media(max-width: 320)': {
    typography: {
      fontSize: 13
    }
  },
  custom: {
    button: {
      indigo: {
        background: 'rgba(46, 14, 253, 1)',
        color: 'white'
      },
      lightDark: {
        background: 'rgba(66, 74, 79, 1)',
        color: 'white'
      },
      teal: {
        background: 'rgba(103, 196, 188, 1)',
        color: 'white'
      },
      blue: {
        background: 'rgba(255, 255, 255, 1)',
        color: 'rgba(56, 160, 235, 1)',
        border: '1px solid rgba(56, 160, 235, 1)',
      }
    }
  },
  overrides: {
    MuiRadio: {
      root: {
        color: '#e0e0e0',
      },
      checked: {},
      disabled: {},
      colorPrimary: {
        '&$checked': {
          color: '#4CE1B6',
        },
        '&$disabled': {
          color: '#000',
        },
      },
      colorSecondary: {
        '&$checked': {
          color: '#4CE1B6',
        },
        '&$disabled': {
          color: '#cccccc',
        },
      },
    },
    MuiCheckbox: {
      root: {
        color: '#e0e0e0',
      },
      checked: {},
      disabled: {},
      indeterminate: {},
      colorPrimary: {
        '&$checked': {
          color: '#4CE1B6',
        },
        '&$disabled': {
          color: '#cccccc',
        },
      },
      colorSecondary: {
        '&$checked': {
          color: '#4CE1B6',
        },
        '&$disabled': {
          color: '#cccccc',
        },
      },
    },
  },
});


// WEBPACK FOOTER //
// ./src/app/Theme.js